import React, { useContext } from "react";
import { Switch, withRouter } from "react-router-dom";
import List from "./List";
import Client from "./Customer";
import { CustomersProvider } from "./CustomersContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";

function Customers(props) {
    const {
        api: {
            Management: { Customers, Visitors },
            General: { Storage },
        },
    } = useContext(AppContext);
    return (
        <CustomersProvider value={{ Customers, Visitors, Storage }}>
            <Switch>
                <PrivateRoute exact path="/customers" component={List} />
                <PrivateRoute exact path="/customers/add" render={(props) => <Client {...props} mode="add" title="" />} />
                <PrivateRoute exact path="/customers/:id" render={(props) => <Client {...props} mode="detail" title="" />} />
                <PrivateRoute
                    exact
                    path="/customers/:id/update"
                    render={(props) => <Client {...props} mode="update" title="" />}
                />
            </Switch>
        </CustomersProvider>
    );
}

export default withRouter(Customers);
